import { SvgIconTypeMap } from '@mui/material';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import { Water, School} from '@mui/icons-material';

export interface AboutBlock {
  title: string;
  subtitle?: string;
  content: string[];
  gradient: string;
  borderColor: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };
}

export const aboutBlocks: AboutBlock[] = [
  {
    title: 'Empresa Pionera',
    subtitle: 'Innovación con IA',
    content: [
      'Vixia System es una empresa pionera especializada en teledetección en medios acuáticos, sensores ambientales y monitorización de la calidad del agua.',
      'Integramos tecnología avanzada y conocimiento científico para ofrecer soluciones en monitorización ambiental, teledetección satelital y análisis hidrológico.',
      'Proponemos sistemas de monitorización continua de parámetros clave, integrados con algoritmos de inteligencia artificial. Estas soluciones permiten clasificar tipos de agua y determinar su naturaleza, facilitando una gestión eficiente del recurso hídrico en sectores como las piscifactorías.'
    ],
    gradient: 'linear-gradient(135deg, rgba(30, 64, 175, 0.8) 0%, rgba(59, 130, 246, 0.8) 100%)',
    borderColor: 'rgba(96, 165, 250, 0.3)',
    icon: Water
  },
  {
    title: 'Nuestro Origen',
    subtitle: 'Departamento de Física Aplicada de la Universidad de Vigo',
    content: [
      'Vixia System, originada en el Departamento de Física Aplicada de la Universidad de Vigo, tiene como objetivo principal abordar la degradación de los recursos hídricos mediante la detección automática, la generación de alarmas y la prevención de episodios de contaminación en aguas continentales y costeras.',
      'De esta forma, contribuimos a preservar la biodiversidad, combatir la contaminación, proteger los espacios naturales, prevenir la erosión, conservar el medio marino y costero, y mejorar la calidad del agua.'
    ],
    gradient: 'linear-gradient(135deg, rgba(30, 64, 175, 0.8) 0%, rgba(59, 130, 246, 0.8) 100%)',
    borderColor: 'rgba(96, 165, 250, 0.3)',
    icon: School
  }
];

export const aboutSectionTitle = 'Sobre Nosotros';